import { styles } from './CircularButton.styles';
import { withPersonalizedIconButtonStyle } from '../icon-button/withPersonalizedIconButtonStyle';
import { IconButton } from '../icon-button/IconButton';
import { CircularIconButtonProps } from './CircularButton.types';
import { mergeStyles } from 'src/_shared/utils/mergeStyles';
import { CIRCULAR_BUTTON_SIZES, CIRCULAR_BUTTON_TYPES } from './CircularButton.constants';

const BUTTON_TYPE_STYLES_MAP = {
  [CIRCULAR_BUTTON_TYPES.FILL]: { button: styles.buttonFill, icon: styles.iconFill },
  [CIRCULAR_BUTTON_TYPES.OUTLINED]: { button: styles.buttonOutlined, icon: styles.iconOutlined },
  [CIRCULAR_BUTTON_TYPES.ONLY_ICON]: { button: styles.buttonOnlyIcon, icon: styles.iconOnlyIcon },
};

const BUTTON_SIZE_AND_TYPE_STYLES_MAP = {
  [CIRCULAR_BUTTON_SIZES.EXTRASMALL]: {
    [CIRCULAR_BUTTON_TYPES.FILL]: { button: styles.buttonExtrasmallFill, icon: styles.iconExtrasmallFill },
    [CIRCULAR_BUTTON_TYPES.OUTLINED]: { button: styles.buttonExtrasmallOutlined, icon: styles.iconExtrasmallOutlined },
    [CIRCULAR_BUTTON_TYPES.ONLY_ICON]: { button: styles.buttonExtrasmallOnlyIcon, icon: styles.iconExtrasmallOnlyIcon },
  },
  [CIRCULAR_BUTTON_SIZES.SMALL]: {
    [CIRCULAR_BUTTON_TYPES.FILL]: { button: styles.buttonSmallFill, icon: styles.iconSmallFill },
    [CIRCULAR_BUTTON_TYPES.OUTLINED]: { button: styles.buttonSmallOutlined, icon: styles.iconSmallOutlined },
    [CIRCULAR_BUTTON_TYPES.ONLY_ICON]: { button: styles.buttonSmallOnlyIcon, icon: styles.iconSmallOnlyIcon },
  },
  [CIRCULAR_BUTTON_SIZES.MEDIUM]: {
    [CIRCULAR_BUTTON_TYPES.FILL]: { button: styles.buttonMediumFill, icon: styles.iconMediumFill },
    [CIRCULAR_BUTTON_TYPES.OUTLINED]: { button: styles.buttonMediumOutlined, icon: styles.iconMediumOutlined },
    [CIRCULAR_BUTTON_TYPES.ONLY_ICON]: { button: styles.buttonMediumOnlyIcon, icon: styles.iconMediumOnlyIcon },
  },
  [CIRCULAR_BUTTON_SIZES.LARGE]: {
    [CIRCULAR_BUTTON_TYPES.FILL]: { button: styles.buttonLargeFill, icon: styles.iconLargeFill },
    [CIRCULAR_BUTTON_TYPES.OUTLINED]: { button: styles.buttonLargeOutlined, icon: styles.iconLargeOutlined },
    [CIRCULAR_BUTTON_TYPES.ONLY_ICON]: { button: styles.buttonLargeOnlyIcon, icon: styles.iconLargeOnlyIcon },
  },
  [CIRCULAR_BUTTON_SIZES.LARGE_COZY]: {
    [CIRCULAR_BUTTON_TYPES.FILL]: { button: styles.buttonLargeCozyFill, icon: styles.iconLargeCozyFill },
    [CIRCULAR_BUTTON_TYPES.OUTLINED]: { button: styles.buttonLargeCozyOutlined, icon: styles.iconLargeCozyOutlined },
    [CIRCULAR_BUTTON_TYPES.ONLY_ICON]: { button: styles.buttonLargeCozyOnlyIcon, icon: styles.iconLargeCozyOnlyIcon },
  },
  [CIRCULAR_BUTTON_SIZES.EXTRALARGE]: {
    [CIRCULAR_BUTTON_TYPES.FILL]: { button: styles.buttonExtralargeFill, icon: styles.iconExtralargeFill },
    [CIRCULAR_BUTTON_TYPES.OUTLINED]: { button: styles.buttonExtralargeOutlined, icon: styles.iconExtralargeOutlined },
    [CIRCULAR_BUTTON_TYPES.ONLY_ICON]: { button: styles.buttonExtralargeOnlyIcon, icon: styles.iconExtralargeOnlyIcon },
  },
};

const Button = ({ style, iconStyle, size, type, ...iconButtonProps }: CircularIconButtonProps) => {
  const newStyle = mergeStyles(
    BUTTON_TYPE_STYLES_MAP[type]?.button,
    BUTTON_SIZE_AND_TYPE_STYLES_MAP[size][type]?.button,
    style,
  );
  const newIconStyle = mergeStyles(
    BUTTON_TYPE_STYLES_MAP[type]?.icon,
    BUTTON_SIZE_AND_TYPE_STYLES_MAP[size][type]?.icon,
    iconStyle,
  );
  return <IconButton style={newStyle} iconStyle={newIconStyle} {...iconButtonProps} />;
};

export const CircularButton = withPersonalizedIconButtonStyle(Button, styles);
